import { useSelector } from "react-redux";
import { selectFlags } from "../../reduxSlices/globalFlagsSlice";
import "./DesktopTab.css";
import Translatable from "../Translatable/Translatable";

interface IPropsTabs {
  handleSelectTab: (tipo: string) => void;
  filtro: string;
}

export default function DesktopTab({ handleSelectTab, filtro }: IPropsTabs) {
  const {isMobileSearchActive} = useSelector(selectFlags);
  return (
    <div className="desktop-subjects-tab min-w-[80px] md:max-w-[320px] md:w-[320px]">
      <p
        className={`desktop-subjects-tab-button ${filtro === "OBLIGATORIO" ? "desktop-tab-active" : ""}`}
        onClick={() => {
          handleSelectTab("OBLIGATORIO");
        }}
      >
        <Translatable as="span" capitalize>{isMobileSearchActive ? "Obl" : "Obligatorias"}</Translatable>
      </p>
      <p
        className={`desktop-subjects-tab-button ${filtro === "OPTATIVO" ? "desktop-tab-active" : ""}`}
        onClick={() => {
          handleSelectTab("OPTATIVO");
        }}
      >
        <Translatable as="span" capitalize>{isMobileSearchActive ? "Opt" : "Optativas"}</Translatable>
      </p>
    </div>
  );
}
